import script from "./WidgetBrowse.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetBrowse.vue?vue&type=script&setup=true&lang=js"

import "./WidgetBrowse.vue?vue&type=style&index=0&id=606ded42&lang=css"

const __exports__ = script;

export default __exports__